var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindemLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 70,
    height: 70,
    rx: 35,
    fill: "#4599FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "#E1EFFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9954 48.5771C26.9954 50.4674 25.4294 51.9998 23.4977 51.9998C21.566 51.9998 20 50.4674 20 48.5771C20 46.6867 21.566 45.1543 23.4977 45.1543C25.4294 45.1543 26.9954 46.6867 26.9954 48.5771Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.1083C20 23.218 21.5324 21.6855 23.4228 21.6855H48.2231C50.1135 21.6855 51.6459 23.218 51.6459 25.1083C51.6459 26.9986 50.1135 28.5311 48.2231 28.5311H23.4228C21.5324 28.5311 20 26.9986 20 25.1083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.8427C20 34.9523 21.5324 33.4199 23.4228 33.4199H38.2297C40.12 33.4199 41.6524 34.9523 41.6524 36.8427C41.6524 38.733 40.12 40.2654 38.2297 40.2654H23.4228C21.5324 40.2654 20 38.733 20 36.8427Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindemLogo);
export default __webpack_public_path__ + "static/media/findem_logo.561758936aaf2d1cea75f9f93a0f266c.svg";
export { ForwardRef as ReactComponent };